import BSubmenu from '../menu/submenu'

/* istanbul ignore next */
BSubmenu.install = function (Vue) {
  Vue.component(BSubmenu.name, BSubmenu)
}

export default BSubmenu
